const calcAvgWithoutLeast = (arr: Array<number>) => {
  let min: number;
  return arr.length > 1
    ? arr.reduce((total, val) => {
        if (!min) {
          min = val;
          return total;
        }
        if (val < min) {
          const newTotal = total + min;
          min = val;
          return newTotal;
        }
        return val + total;
      }, 0) /
        (arr.length - 1)
    : arr[0] || 0;
};

export default calcAvgWithoutLeast;
